<template>
	<div @click="openEditor" class="offer_status btn" :style="{ 'background-color': getStatusColorData.background, color: getStatusColorData.text }">
		<p>{{payload.status}}</p>
	</div>
</template>
<script>
	import { mapMutations } from 'vuex'
	import OffersHelper from '@/classes/offers_helper.js'
	export default {
		name: 'offer-status',
		props: ['payload'],
		data(){
			return {
				offers_helper: new OffersHelper(),
			}
		},
		computed: {
			getStatusColorData(){
				if(this.offers_helper.getOrangeStatuses().includes(this.payload.status)){
					return { background: 'darkorange', text: 'white' }
				}
				if(this.offers_helper.getRedStatuses().includes(this.payload.status)){
					return { background: 'red', text: 'white' }
				}
				if(this.offers_helper.getGreenStatuses().includes(this.payload.status)){
					return { background: 'green', text: 'white' }
				}
			},
		},
		methods: {
			openEditor(){
				this.createModal({
					component_name: 'FieldForm',
					modal_title: `Edit Offer Status`,
					field_name: 'status',
					value: this.payload.status,
					resource_id: this.payload.id,
					resource_type: 'Offer',
					field_type: 'select',
					select_options: this.offers_helper.getFiltersOptions()
				})
			},
			...mapMutations('modals', ['createModal'])
		}
	}
</script>
<style scoped>
	.offer_status{
		border-radius: 30px;
		padding: 5px 10px;
		display: inline-block;
	}
</style>